/* eslint-disable import/prefer-default-export */
import styled from 'styled-components'

import {
  accent,
  background1,
  background2,
  darkAccent,
} from '../../../../styles/colors'
import {
  center,
  hFlex,
  overlay,
  singleLineText,
} from '../../../../styles/style-helpers'

export const RecordedHomeEl = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  background: ${background1};
  padding: 1em 0 7.5em;

  .title {
    position: relative;
    width: 100%;
    padding-bottom: 0.75em;
    margin: 2em 0 1.5em;
    text-transform: uppercase;
    letter-spacing: 0.0125em;
    font-weight: bold;

    &:after {
      content: '';
      position: absolute;
      top: 100%;
      left: 0;
      width: 5em;
      height: 1px;
      background: ${accent};
    }
  }
`

export const RegisterEl = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: black;
  padding: 1em;
  ${hFlex};
  justify-content: space-between;

  .fee {
    opacity: ${({ hideFee }) => (hideFee ? 0 : 1)};

    p {
      width: fit-content;
      position: relative;
      color: #b3b3b3;

      &:after {
        content: '';
        ${center};
        width: 100%;
        height: 1px;
        background: white;
      }
    }

    h4 {
      color: white;

      span {
        margin-left: 0.5em;
        font-size: 0.64em;
        letter-spacing: 0.025em;
      }
    }
  }
`

export const CoverEl = styled.div`
  width: 100%;
  padding: 1em;
  margin-bottom: 1em;

  .container {
    position: relative;
    width: 100%;
    height: calc(${(100 * 9) / 16}vw - ${(2 * 9) / 16}em);
    background: #232323;
    border-radius: 0.5em;
    overflow: hidden;

    .cover {
      ${overlay};

      > div {
        width: 100%;
        height: 100%;

        > div {
          width: 100%;
          height: 100%;
          padding-top: unset;
        }

        > img {
          object-fit: cover;
        }
      }

      video {
        height: 100%;
        width: 100%;
      }

      .MuiIconButton-root {
        ${center};
        z-index: 1;

        .MuiSvgIcon-root {
          font-size: 2.5em;
          fill: white;
        }
      }
    }
  }
`

export const AboutEl = styled.div`
  width: 100%;
  padding: 1em;
  margin-bottom: 1em;

  > h4 {
    margin-bottom: 0.25em;
    font-weight: bold;
  }

  > a {
    p {
      span {
        color: ${accent};
      }
    }
  }
`

export const DetailsEl = styled.div`
  width: 100%;
  padding: 1em 1em;

  .detail {
    width: 100%;
    ${hFlex};
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 1.5em;

    &:last-of-type {
      margin-bottom: 0;
    }

    .MuiSvgIcon-root {
      margin-right: 0.5em;
    }

    > p {
      line-height: 1.5;
    }
  }
`

export const DescriptionEl = styled.div`
  width: 100%;
  padding: 2.5em 1em;
  margin: 2.5em 0;
  background: ${background2};

  .description {
    line-height: 1.5;

    ol,
    ul {
      padding-left: 2em;

      li {
        margin: 0.5em 0;
      }
    }

    a {
      color: ${darkAccent};
      text-decoration: underline;
    }
  }
`

export const ArtistEl = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vw;
`

export const ContentEl = styled.div`
  position: relative;
  width: 100%;
  padding: 0 1em;
  margin: 5em 0;

  .title {
    margin-top: 2.5em;
  }

  .rtfContent {
    line-height: 1.5;

    ol,
    ul {
      padding-left: 2em;
    }
  }

  .chapters {
    position: relative;
    width: 100%;

    .chapter {
      margin: 2em 0 3em;

      &:last-of-type {
        margin-bottom: 0;
      }

      .index {
        text-transform: uppercase;
        color: #777;
        margin-bottom: 0.5em;
        letter-spacing: 0.025em;
      }

      .name {
        ${hFlex};
        justify-content: flex-start;
        line-height: 1.5;
        margin: 0.75em 0;

        .MuiSvgIcon-root {
          margin-right: 0.5em;
        }
      }

      .rtfContent {
        color: #999;
        margin-bottom: 1em;
        padding-left: 2.25em;
      }

      .lessons {
        padding-left: 2.25em;

        .lesson {
          padding-left: 0.5em;
        }
      }
    }
  }
`

export const ReviewsEl = styled.div`
  position: relative;
  width: 100%;
  padding: 5em 1em 0;

  .review {
    padding: 1em 0;
    margin-bottom: 2em;

    .user {
      width: 100%;
      ${hFlex};
      padding-bottom: 1em;
      margin-bottom: 1em;
      border-bottom: 1px solid #d0d0d0;

      .MuiAvatar-root {
        height: 2.25em;
        width: 2.25em;
        font-size: 1em;
        text-transform: uppercase;
        letter-spacing: 0.025em;
        margin-right: 0.5em;
      }

      > p {
        flex: 1;
        ${singleLineText};
        text-transform: capitalize;
      }
    }

    .reviewText {
      line-height: 1.5;
    }

    .time {
      width: 100%;
      margin-top: 1em;
      text-align: right;
      color: #777;
    }
  }
`

export const RegisteredEl = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: black;
  padding: 1em;
  ${hFlex};
  justify-content: space-between;

  .MuiButton-root {
    flex: 1;
    max-width: 50%;

    &:first-of-type {
      margin-right: 1em;
    }

    &:last-of-type {
      margin-right: 0 !important;
    }
  }
`
